import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ExpandMore, ExpandLess } from '@mui/icons-material';

const HomeFAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'What services does Bizani Media offer?',
      answer: 'We offer comprehensive media production services including video production, documentaries, branding, digital content creation, and creative communication strategies.'
    },
    {
      question: 'How long does a typical project take?',
      answer: 'Project timelines vary depending on scope and complexity. A typical video project can take 2-6 weeks, while branding projects may take 4-8 weeks. We provide detailed timelines during the initial consultation.'
    },
    {
      question: 'Do you work with clients outside of Zimbabwe?',
      answer: 'Yes, we work with clients globally. While we are based in Zimbabwe, we have experience working with international organizations and can accommodate remote collaboration.'
    },
    {
      question: 'What is your creative process?',
      answer: 'Our process begins with understanding your brief and objectives. We then develop a creative concept, execute the production, and deliver the final product with your feedback incorporated throughout the process.'
    },
    {
      question: 'Can you help with social media content?',
      answer: 'Absolutely! We create engaging social media content including photography, graphic design, and short-form videos tailored to your platform and audience.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-black text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* FAQ Section on the left */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2
              className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8"
              style={{ 
                fontFamily: "'Montserrat', sans-serif",
                color: '#EF3F23'
              }}
            >
              Frequently Asked Questions
            </h2>

            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className="border-b border-white/20"
                >
                  <button
                    onClick={() => toggleFAQ(index)}
                    className="w-full text-left py-4 flex items-center justify-between group"
                  >
                    <h3
                      className="text-lg font-semibold pr-4 group-hover:text-bizani-orange transition-colors duration-200"
                      style={{ fontFamily: "'Montserrat', 'Poppins', sans-serif" }}
                    >
                      {faq.question}
                    </h3>
                    <motion.div
                      animate={{ rotate: openIndex === index ? 180 : 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      {openIndex === index ? (
                        <ExpandLess style={{ color: '#EF3F23', fontSize: '24px' }} />
                      ) : (
                        <ExpandMore style={{ color: '#EF3F23', fontSize: '24px' }} />
                      )}
                    </motion.div>
                  </button>
                  
                  <motion.div
                    initial={false}
                    animate={{
                      height: openIndex === index ? 'auto' : 0,
                      opacity: openIndex === index ? 1 : 0
                    }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <p
                      className="pb-4 text-gray-300 leading-relaxed"
                      style={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                      {faq.answer}
                    </p>
                  </motion.div>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Newsletter Section on the right */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:sticky lg:top-20"
          >
            <div className="bg-black rounded-lg p-8 border border-white/20">
              <h2
                className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4"
                style={{ 
                  fontFamily: "'Montserrat', sans-serif",
                  color: '#EF3F23'
                }}
              >
                Stay Connected
              </h2>
              <p
                className="text-gray-300 mb-6 leading-relaxed"
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                Subscribe to our newsletter to receive updates on our latest projects, creative insights, and industry news.
              </p>

              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  // Handle newsletter subscription
                  alert('Thank you for subscribing!');
                }}
                className="space-y-4"
              >
                <div>
                  <input
                    type="email"
                    placeholder="Enter your email address"
                    required
                    className="w-full px-4 py-3 rounded-lg bg-black border border-white/20 text-white placeholder-white/50 focus:outline-none focus:border-bizani-orange transition-colors duration-200"
                    style={{ fontFamily: "'Poppins', sans-serif" }}
                  />
                </div>
                <button
                  type="submit"
                  className="w-full px-6 py-3 rounded-lg font-bold text-white transition-all duration-300 shadow-lg hover:shadow-xl"
                  style={{ 
                    backgroundColor: '#EF3F23',
                    fontFamily: "'Poppins', sans-serif"
                  }}
                >
                  Subscribe
                </button>
              </form>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HomeFAQ;
